import { render, staticRenderFns } from "./issuable_stats.vue?vue&type=template&id=91cd914a"
import script from "./issuable_stats.vue?vue&type=script&lang=js"
export * from "./issuable_stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports